import { render } from "./NYFormTextarea.vue?vue&type=template&id=2c5bd1cc&scoped=true"
import script from "./NYFormTextarea.vue?vue&type=script&lang=js"
export * from "./NYFormTextarea.vue?vue&type=script&lang=js"

import "./NYFormTextarea.vue?vue&type=style&index=0&id=2c5bd1cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5bd1cc"]])

export default __exports__